<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div v-if="1 == 2" class="top flexStyle1">
      <div class="item" v-for="(item, index) of 5" :key="index">
        <img v-if="index === 0" src="../../images/footer1.png" class="img" />
        <img
          v-else-if="index === 1"
          src="../../images/footer2.png"
          class="img"
        />
        <img
          v-else-if="index === 2"
          src="../../images/footer3.png"
          class="img"
        />
        <img
          v-else-if="index === 3"
          src="../../images/footer4.png"
          class="img"
        />
        <img
          v-else-if="index === 4"
          src="../../images/footer5.png"
          class="img"
        />
      </div>
    </div>
    <div class="top flexStyle2">
      <div class="item2" >
        <div class="img1">
           <div class="imgs1"></div>
          <!-- <img  src="../../images/footers1.png" class="imgs1"/> -->
           <div>正品保证</div>
        </div>
        <div class="img1">
          <div class="imgs2"></div>
           <div>随心选择</div>
        </div>
        <div class="img1">
          <div class="imgs3"></div>
           <div>免费送货</div>
        </div>
        <div class="img1">
          <div class="imgs4"></div>
           <div>定制设计</div>
        </div>
         <div class="img1">
          <div class="imgs5"></div>
           <div>优选品质</div>
        </div>
        <div class="img1">
         <div class="imgs6"></div>
           <div>送礼方便</div>
        </div>
        <!-- <img  src="../../images/footer.png" class="img" /> -->
      </div>
    </div>
     <hr/>
    <div class="middle flexStyle1">
      <div class="main ">
        <div class="left flexStyle2">
         
          <div
            class="list"
            v-for="(item, index) of currentPageInfo"
            :key="index"
          >
          
            <div class="top">{{ item.article_type_name }}</div>
            <div class="bottom">
              <div
                @click="watchQA(item2.article_id)"
                v-for="(item2, index2) of item.list"
                :key="index2"
                class="item hands oneLine c-animation"
              >
                 {{ item2.article_title }}
              </div>
            </div>
          </div>
        </div>
        <div class="middle"></div>
        <div class="right flexStyle1">
          <!-- <div class="left">
            <img src="../../images/footer6.png" class="img" />
          </div>
           <div class="right">
            <div class="top">客服热线</div>
            <div class="middle" v-if="!web_tel">
              <div class="item">400-000-000</div>
            </div>
            <div class="middle" v-else>
              <div class="item" v-for="(item, index) of web_tel" :key="index">
                {{ item || "400-000-000" }}
              </div>
            </div>
            <div class="bottom">周一至周六早9点一晚17点半</div>
          </div>  -->
        </div>
      </div>
    </div>
    <div v-if="web_icp" class="bottom">
      <div class="center center2">版权所有:{{ web_copyright }}</div>
      <div @click="goIcp" class="center hands">备案号:{{ web_icp }}</div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import { helperCenter1nd2Request } from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      web_tel: "", // 1.1.客户电话
      web_icp: "", // 1.2.备案号
      currentPageInfo: {}, // 1.3.currentPageInfo
      sysId: "", // 1.4.sysId
      web_copyright: "", // 1.5.版权所有
    };
  },

  methods: {
    // 2.methods
    goIcp() {
      // 2.1.去备案号官网查看
      window.location = "http://beian.miit.gov.cn/";
    },

    getCurrentPageInfo() {
      // 2.2.getCurrentPageInfo
      let data = {
        sysId: this.sysId,
      };

      helperCenter1nd2Request(data).then((res) => {
        if (res) {
          this.currentPageInfo = res.data;
        }
      });
    },

    watchQA(articleId) {
      // 2.3.查看文章
      if (this.$route.path != "/helpCenter") {
        this.$router.push(
          "/helpCenter?obj=" + encodeURIComponent(JSON.stringify({ articleId }))
        );
      } else {
        this.$emit("watchQA", articleId);
      }
    },

    clearAllTimer() {
      clearInterval(this.web_telTimer);
      clearInterval(this.getSysidTimer);
      clearInterval(this.web_copyrightTimer);
      clearInterval(this.web_icpTimer);
    },
  },

  props: {
    // 3.props
  },

  mounted() {
    // 4.mounted
    this.web_telTimer = setInterval(() => {
      if (localStorage.web_tel) {
        clearInterval(this.web_telTimer);
        this.web_tel = JSON.parse(localStorage.web_tel);
      }
    }, 200);

    this.getSysidTimer = setInterval(() => {
      if (localStorage.sysId) {
        clearInterval(this.getSysidTimer);
        this.sysId = localStorage.sysId;
        this.getCurrentPageInfo();
      }
    }, 200);

    this.web_copyrightTimer = setInterval(() => {
      if (localStorage.web_copyright) {
        clearInterval(this.web_copyrightTimer);
        this.web_copyright = localStorage.web_copyright;
      }
    }, 200);

    this.web_icpTimer = setInterval(() => {
      if (localStorage.web_icp) {
        clearInterval(this.web_icpTimer);
        this.web_icp = localStorage.web_icp;
      }
    }, 200);
  },

  destroyed() {
    this.clearAllTimer();
  },
};
</script>

<style lang="scss" scoped>
@import "./footer.scss";
</style>
